export default "__VITE_ASSET__3f4XB4Mp__"